import Colors from "../colors";

const styles = {
  tableRow: {
    textAlign: "center",
    // backgroundColor: Colors.white,
    // border: "none",
  },
  locationIcon: {
    height: ".8rem",
    width: "1rem",
  },
  icon: {
    height: ".7rem",
    width: "1rem",
  },
  tableRowForMArkAttendance: {
    backgroundColor: Colors.white,
    border: "1px solid #C4C4C4",
    borderRadius: "3px",
  },
  sizes: {
    tiny: {
      maxWidth: "3.5rem",
    },
    mini: {
      maxWidth: "5rem",
    },
    small: {
      maxWidth: "6rem",
    },
    medium: {
      maxWidth: "10rem",
    },
  },
};

export default styles;
